export enum ServiceType {
  HR = 'hr-templates',
  COMPLIANCE = 'compliance-recall',
  RARE_EARTH_PERMIT = 'rare-earth-permit',
  TRADE = '5g-recommerce',
  INTELLIGENCE = 'raid-to-revenue',
  VERPACKG = 'verpackg-loschung'
}

export interface ServiceConfig {
  id: ServiceType
  name: string
  description: string
  shortDescription: string
  baseUrl?: string // Made optional since it's generated dynamically
  pricing: string
  ctaText: string
  icon: string
  features: string[]
  isActive: boolean
  isComingSoon?: boolean
  accentColor: string
  status: 'active' | 'inactive' | 'error'
  // Environment-specific configuration
  subdomain?: string
  localPort?: number
  packagePath?: string
  framework?: 'nextjs' | 'vite'
}

export interface CTAButton {
  text: string
  href?: string
  onClick?: () => void
  variant: 'primary' | 'secondary'
}

export interface HeroSectionProps {
  title: string
  subtitle: string
  primaryCTA: CTAButton
  secondaryCTA: CTAButton
}

export interface ServiceCardProps {
  service: ServiceConfig
  onServiceClick: (serviceType: ServiceType) => void
  className?: string
}

export interface HeaderNavProps {
  currentService?: ServiceType
  isScrolled: boolean
  showMobileMenu: boolean
  onToggleMobileMenu: () => void
}

export interface BreadcrumbItem {
  label: string
  href: string
  current?: boolean
}

export interface BreadcrumbProps {
  path: BreadcrumbItem[]
}